module.exports = __webpack_public_path__ + "static/media/hands_up.b46c8d35.svg";